import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors } from '../../layout/theme-next';

const commonButtonStyles = {
  margin: 0,
  boxShadow: 'none',
  borderRadius: 100,
  'text-transform': 'capitalize',
};
export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      padding: theme.spacing(4, 5),
    },
    item: {
      height: '77vh',
      width: '100%',
    },
    link: {
      textDecoration: 'none',
    },
    createButton: {
      ...commonButtonStyles,
      background: Colors.primary,
      color: Colors.white,
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: theme.spacing(1),
      },
      '& .MuiButton-endIcon': {
        marginLeft: theme.spacing(1),
        marginRight: 0,
      },
      '&:hover': {
        background: Colors.primary,
      },
    },
    createButtonTooltipTarget: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    createButtonLockIcon: {
      fontSize: 12,
      color: Colors.stroke,
    },
    createActionGroup: {
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      marginLeft: theme.spacing(0.5),
    },
    clearButton: {
      margin: '0px 16px 0px 0px',
      backgroundColor: theme.palette.common.white,
    },
    exportListbutton: {
      ...commonButtonStyles,
      marginRight: theme.spacing(1.875),
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      border: `1px solid ${Colors.primary}`,
      backgroundColor: Colors.white,
      color: Colors.primary,
    },
    errorBlock: {
      color: 'red',
    },
  }),
);
